import * as Actions from '../../actions/customer/type';

const initialState = {
  addCustomerVehicleLoading: false,
  addCustomerVehicleSuccess: '',
  addCustomerVehicleError: '',

  addCustomerLoading: false,
  addCustomerSuccess: '',
  addCustomerError: '',

  deleteCustomerLoading: false,
  deletedCustomer: '',
  deleteCusErr: '',

  getCustomerListLoading: false,
  customerList: [],
  customerDetails: null,
  customerDetailsLoading: false,
  customerDetailsError: '',
  error: '',
  loading: false,

  serviceLoader: false,
  serviceHistory: '',
  serviceHistoryError: '',

  updateCustomerSuccess: '',

  exportCustomer: '',

  importCustomerData: '',
  importCustomerError: '',
  count: 0,
};
export const CustomerReducer = (state = initialState, action) => {
  switch (action.type) {
    // add customer, vehicle

    case Actions.ADD_CUSTOMER_VEHICLE_REQUEST:
      return { ...state, addCustomerVehicleLoading: true };
    case Actions.ADD_CUSTOMER_VEHICLE_SUCCESS:
      const customers = [...state.customerList];

      if (action.payload?.data?.customerData?.id) {
        customers.push(action.payload.data.customerData);
      }
      return {
        ...state,
        addCustomerVehicleLoading: false,
        addCustomerVehicleSuccess:
          {
            message: action.payload.message || 'Success',
            data: action.payload.data.customerData,
          } || 'Success',
        customerList: customers,
        count: state?.count + 1 || 0,
      };

    case Actions.ADD_CUSTOMER_VEHICLE_FAIL:
      return {
        ...state,
        addCustomerVehicleLoading: false,
        addCustomerVehicleError: action.payload,
      };

    case Actions.CLEAR_ADD_CUSTOMER_VEHICLE_STATE:
      return {
        ...state,
        addCustomerVehicleLoading: false,
        addCustomerVehicleSuccess: '',
        addCustomerVehicleError: '',
      };

    // add customer

    case Actions.ADD_CUSTOMER_REQUEST:
      return { ...state, addCustomerLoading: true };
    case Actions.ADD_CUSTOMER_SUCCESS:
      return {
        ...state,
        addCustomerLoading: false,
        addCustomerSuccess: action.payload?.data?.customerData || '',
      };

    case Actions.ADD_CUSTOMER_FAIL:
      return {
        ...state,
        addCustomerLoading: false,
        addCustomerError: action.payload,
      };

    case Actions.CLEAR_ADD_CUSTOMER_STATE:
      return {
        ...state,
        addCustomerLoading: false,
        addCustomerSuccess: '',
        addCustomerError: '',
      };

    // delete customer

    case Actions.DELETE_CUSTOMER_REQUEST:
      return { ...state, deleteCustomerLoading: true };
    case Actions.DELETE_CUSTOMER_SUCCESS:
      return {
        ...state,
        deleteCustomerLoading: false,
        deletedCustomer: action.payload?.data || '',
      };

    case Actions.DELETE_CUSTOMER_FAIL:
      return {
        ...state,
        deleteCustomerLoading: false,
        deleteCusErr: action.payload,
      };
    // updating list after deleting
    case Actions.UPDATE_CUSTOMER_LIST_ON_DELETE:
      const deletedCustomerId = action?.payload?.id;
      const filteredList = state.customerList?.filter(
        (cus) => cus?.id !== deletedCustomerId,
      );
      return {
        ...state,
        customerList: filteredList,
        count: state?.count - 1,
      };

    // clearing deleted customer state
    case Actions.CLEAR_DELETED_CUSTOMER_STATE:
      return {
        ...state,
        deleteCustomerLoading: false,
        deletedCustomer: '',
        deleteCusErr: '',
      };
    // Get customer card listing

    case Actions.GET_CUSTOMER_LISTING_REQUEST:
      return {
        ...state,
        getCustomerListLoading: true,
      };
    case Actions.GET_CUSTOMER_LISTING_SUCCESS:
      return {
        ...state,
        getCustomerListLoading: false,
        customerList: action?.payload?.customers || [],
        count: action?.payload?.count || 0,
        totalCount: action?.payload?.totalCount,
      };
    case Actions.GET_CUSTOMER_LISTING_FAIL:
      return {
        ...state,
        getCustomerListLoading: false,
        error: action.payload,
      };
    case Actions.UPDATE_CUSTOMERS_LISTING: {
      // on update customer from listing then also update listing as well
      const customerList = state.customerList || [];
      const updatedCustomerId = action.payload?.id || '';
      const foundIndex = customerList.findIndex(
        (x) => x.id === updatedCustomerId,
      );

      if (foundIndex > -1) {
        customerList[foundIndex] = action.payload;
      }

      return {
        ...state,
        customerList,
      };
    }
    case Actions.UPDATE_CUSTOMERS_LIST: {
      // on update customer from listing then also update listing as well
      const customerList = state.customerList || [];
      const updatedCustomerId = action.payload?.id || '';
      const foundIndex = customerList.findIndex(
        (x) => x.id === updatedCustomerId,
      );

      if (foundIndex > -1) {
        customerList[foundIndex] = {
          ...customerList[foundIndex],
          vehicles: [
            ...customerList[foundIndex].vehicles,
            action.payload.vehicle,
          ],
        };
      }

      return {
        ...state,
        customerList,
      };
    }

    // Get Customer

    case Actions.GET_CUSTOMER_REQUEST:
      return {
        ...state,
        customerDetailsLoading: true,
      };
    case Actions.GET_CUSTOMER_SUCCESS:
      return {
        ...state,
        customerDetailsLoading: false,
        customerDetails: action?.payload || {},
      };
    case Actions.GET_CUSTOMER_FAIL:
      return {
        ...state,
        customerDetailsLoading: false,
        customerDetailsError: action.payload,
      };

    // Update Customer

    case Actions.UPDATE_CUSTOMER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case Actions.UPDATE_CUSTOMER_SUCCESS:
      return {
        ...state,
        loading: false,
        updateCustomerSuccess: action.payload || '',
      };
    case Actions.UPDATE_CUSTOMER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        updateCustomerSuccess: '',
      };

    // Get Service History

    case Actions.GET_SERVICE_HISTORY_REQUEST:
      return {
        ...state,
        serviceLoader: true,
      };
    case Actions.GET_SERVICE_HISTORY_SUCCESS:
      return {
        ...state,
        serviceLoader: false,
        serviceHistory: action?.payload?.data || {},
      };
    case Actions.GET_SERVICE_HISTORY_FAIL:
      return {
        ...state,
        serviceLoader: false,
        serviceHistoryError: action?.payload,
      };

    case Actions.CLEAR_UPDATE_CUSTOMER_STATE:
      return {
        ...state,
        loading: false,
        error: '',
        updateCustomerSuccess: '',
      };

    // Export Customer

    case Actions.EXPORT_CUSTOMER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case Actions.EXPORT_CUSTOMER_SUCCESS:
      return {
        ...state,
        loading: false,
        exportCustomer: action.payload || '',
      };
    case Actions.EXPORT_CUSTOMER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        exportCustomer: '',
      };

    case Actions.CLEAR_EXPORT_CUSTOMER_STATE:
      return {
        ...state,
        loading: false,
        error: '',
        exportCustomer: '',
      };

    // Import Customer Vehicle

    case Actions.IMPORT_CUSTOMER_VEHICLE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case Actions.IMPORT_CUSTOMER_VEHICLE_SUCCESS:
      return {
        ...state,
        loading: false,
        importCustomerData: action.payload,
      };
    case Actions.IMPORT_CUSTOMER_VEHICLE_FAIL:
      return {
        ...state,
        loading: false,
        importCustomerError: action.payload,
      };

    case Actions.CLEAR_IMPORT_CUSTOMER_VEHICLE_STATE:
      return {
        ...state,
        loading: false,
        importCustomerError: '',
        importCustomerData: '',
      };

    // Search Customer
    case Actions.SEARCH_CUSTOMER_REQUEST:
      return {
        ...state,
        searchCustomerLoading: true,
        searchedCustomers: [],
        searchCustomerError: '',
      };
    case Actions.SEARCH_CUSTOMER_SUCCESS:
      return {
        ...state,
        searchCustomerLoading: false,
        searchedCustomers: action?.payload?.data || [],
      };
    case Actions.SEARCH_CUSTOMER_FAIL:
      return {
        ...state,
        searchCustomerLoading: false,
        searchCustomerError: action.payload,
      };
    case Actions.CLEAR_SEARCH_CUSTOMER_STATE:
      return {
        ...state,
        searchCustomerLoading: false,
        searchCustomerError: '',
        searchedCustomers: '',
      };

    default:
      return state;
  }
};
